import { initializeApp } from 'firebase/app';

// src/adapters/firebase/app.ts
var app = initializeApp({
  apiKey: "AIzaSyA8PMvwfFiD_fM1tn0X0_aI-TtICuNbmUg",
  authDomain: "flat-kobo-kaitori.firebaseapp.com",
  projectId: "flat-kobo-kaitori",
  storageBucket: "flat-kobo-kaitori.appspot.com",
  messagingSenderId: "548360051419",
  appId: "1:548360051419:web:3cf7021c89f83781dfcafe",
  measurementId: "G-HF4MM1ZT22"
});

export { app };
//# sourceMappingURL=chunk-ABZ5OBXE.mjs.map
//# sourceMappingURL=chunk-ABZ5OBXE.mjs.map